import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ForgetPasswordComponent } from './components/forget-password/forget-password.component';
// import { DashboardComponent } from './components/dashboard/dashboard.component';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { AuthGuard } from './Core/Auth/auth.guard';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { RetailerRegisterComponent } from './components/retailer-Register/retailer-Register.component';
import { ApproveUserComponent } from './components/approve-user/approve-user.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { ApproveStoreCampaignComponent } from './components/approve-store-campaign/approve-store-campaign.component';
import { ApproveBusinessuserCampaignComponent } from './components/approve-businessuser/approve-business-user.component';
import { OtpValidateComponent } from './components/otp-validate/otp-validate.component';
import { CrmTermsComponent } from './shared/crm-site/crm-terms/crm-terms.component';
import { CrmPrivacyPolicyComponent } from './shared/crm-site/crm-privacy-policy/crm-privacy-policy.component';
import { CrmCookiePolicyComponent } from './shared/crm-site/crm-cookie-policy/crm-cookie-policy.component';
import { BannerComponent } from './shared/widgets/banner/banner.component';
import { AnalyticsComponent } from './components/analytics/analytics.component';
import { CollectionComponent } from './components/collection/collection.component';

const routes: Routes = [
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    //canActivateChild: [AuthGuard],
    // pathMatch: 'full',
    children: [
      { path: 'dashboard', loadChildren: () => import('./components/dashboard/dashboard.module').then(m => m.DashboardModule) },
      { path: 'campaigns', loadChildren: () => import('./components/campaigns/campaigns.module').then(m => m.CampaignsModule) },
      { path: 'retail-store', loadChildren: () => import('./components/retail-store/retail-store.module').then(m => m.RetailStoreModule) },
      { path: 'coupons', loadChildren: () => import('./components/coupon/coupon.module').then(m => m.CouponModule) },
      { path: 'products', loadChildren: () => import('./components/products/product.module').then(m => m.ProductModule) },
      { path: 'collection', component: CollectionComponent },
      { path: 'category-management', loadChildren: () => import('./components/products/category-management/category-management.module').then(m => m.CategoryManagementModule) },
      { path: 'games', loadChildren: () => import('./components/games/games.module').then(m => m.GamesModule) },
      { path: 'delegate-access', loadChildren: () => import('./components/delegate-access/delegate-access.module').then(m => m.DelegateAccessModule) },
      { path: 'video', loadChildren: () => import('./components/Video-Tutorial/video-tutorial.module').then(m => m.VideoTutorialModule) },
      { path: 'giftcard', loadChildren: () => import('./components/giftcard/giftcard.module').then(m => m.GiftcardModule) },
      { path: 'users', loadChildren: () => import('./components/users/user.module').then(m => m.UserModule) },
      { path: 'business-users', loadChildren: () => import('./components/business-user/business-user.module').then(m => m.BusinessUserModule) },
      { path: 'subscriptions', loadChildren: () => import('./components/subscriptions/subscription.module').then(m => m.SubscriptionModule) },
      { path: 'partner-portal', loadChildren: () => import('./components/partner-portal/partner-portal.module').then(m => m.PartnerPortalModule) },
      { path: 'role-management', loadChildren: () => import('./components/role-management/role-management.module').then(m => m.RoleManagementModule) },
      { path: 'organization-users', loadChildren: () => import('./components/organization-users/organization-role.module').then(m => m.OrganizationUserModule) },
      { path: 'organization-role-management', loadChildren: () => import('./components/organization-role-management/organization-role-management.module').then(m => m.OrganisationRoleManagementModule) },
      { path: 'contact-us', loadChildren: () => import('./components/contact-us/contact-us.module').then(m => m.ContactUsModule) },
      { path: 'notification', loadChildren: () => import('./components/notification/notification.module').then(m => m.NotificationModule) },
      { path: 'customers', loadChildren: () => import('./components/customers/customers.module').then(m => m.CustomerModule) },
      { path: 'reports', loadChildren: () => import('./components/reports/reports.module').then(m => m.ReportModule) },
      { path: 'vcard-contact', loadChildren: () => import('./components/vcard-contact/vcard-contact.module').then(m => m.VcardContactModule) },
      // { path: '', loadChildren: () => import('./components/dashboard/dashboard.module').then(m => m.DashboardModule) },
      { path: 'banner', loadChildren: () => import('./components/banner/banner.module').then(m => m.BannerModule) },
      { path: 'analytics', component: AnalyticsComponent }
    ]
  },
  {
    path: '',
    component: LoginComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'register',
    component: RegisterComponent,
  },
  {
    path: 'business-register',
    component: RetailerRegisterComponent,
  },
  {
    path: 'store-register',
    component: RetailerRegisterComponent,
  },
  {
    path: 'partner-register',
    component: RetailerRegisterComponent,
  },
  {
    path: 'store-approve',
    component: ApproveUserComponent,
  },
  {
    path: 'store-campaign-approve',
    component: ApproveStoreCampaignComponent,
  },
  {
    path: 'store-businessuser-approve',
    component: ApproveBusinessuserCampaignComponent,
  },
  {
    path: 'forget-password',
    component: ForgetPasswordComponent,
  }
  ,
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
  },
  {
    path: 'otp-validate',
    component: OtpValidateComponent,
  },
  {
    path: 'terms',
    component: CrmTermsComponent
  },
  {
    path: 'privacy-policy',
    component: CrmPrivacyPolicyComponent
  },
  {
    path: 'cookie',
    component: CrmCookiePolicyComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class AppRoutingModule { }
